import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { suggestTags, clearSuggestedTags } from 'actions/tags'
import EntityPicker from 'components/EntityPicker'
import SearchIcon from 'icons/TagIcon'
import styles from './TagPicker.css'

const defaultRenderTag = t => {
  return <div>{t.tag}</div>
}

class TagPicker extends Component {
  constructor(props) {
    super(props)
    this.handlePickTag = this.handlePickTag.bind(this)
  }
  handlePickTag({ tag }) {
    let { input: { onChange } } = this.props
    onChange(tag)
  }
  render() {
    let {
      alwaysShowEntities = false,
      getSuggestions,
      clearSuggestions,
      suggestions = [],
      blacklist = [],
      intl,
      canPick,
      input: { value, onChange } = {},
      renderTag = defaultRenderTag
    } = this.props
    return (
      <EntityPicker
        className={styles.tag_picker + " NsEntityPicker"}
        classes={styles}
        value={value}
        onChange={onChange}
        alwaysShowEntities={alwaysShowEntities}
        entityTypeName="tag"
        searchIcon={SearchIcon}
        suggestions={suggestions}
        blacklist={blacklist}
        getSuggestions={getSuggestions}
        clearSuggestions={clearSuggestions}
        onPickEntity={this.handlePickTag}
        canPickEntity={canPick}
        renderEntity={renderTag}
      />
    )
  }
}

const mapStateToProps = ({
  tags: { list: { loading, error, values, range } = {}, map }
}) => ({
  suggestions: values ? values.map(t => map[t]) : []
})
const mapDispatchToProps = (dispatch, props) => {
  let suggest = bindActionCreators(suggestTags, dispatch)
  return {
    getSuggestions: filter => {
      suggest(filter, props.language || 'en')
    },
    clearSuggestions: bindActionCreators(clearSuggestedTags, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TagPicker)
